import React from 'react'
import { ADDRESS, EMAIL, MOBILE } from '../../../app/constants'
import TermsAndConditions from '../../Checkout/TermsAndConditions'

const ContactInfo = ({ textColor }) => {
    return (
        <div className='mobile-contact-info' style={{ paddingTop: "10px" }}>
            <div>
                <address className="address" style={{ color: textColor }}>
                    <div>Address: {ADDRESS}</div>
                    <div>Call Us: {MOBILE}</div>
                    <div>Email: {EMAIL}</div>
                    <TermsAndConditions />
                </address>
            </div>
            <div>
                <ul className="social-link" >
                <li>
                        <a href="https://www.instagram.com/sportsgallery.cricket/"><i className="fa fa-instagram" ></i></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/sportsgallery.badminton/"><i className="fa fa-instagram" ></i></a>
                    </li>
                    <li>
                        <a href="#!"><i className="fa fa-facebook" ></i></a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/@SPORTSGALLERY.Tirupur"><i className="fa fa-youtube" ></i></a>
                    </li>
                   
                </ul>
            </div>
        </div>
    )
}

export default ContactInfo
